
// COLORS 
export const Colors = {
  black: '#000000',
  dark: '#0B0B0B',
  lightGrey: '#D8D8D8',
  mediumGrey: '#ADADAD',
  grey: '#727272',
  darkGrey: '#3C3C3C',
  extraLightGrey: '#EBEBEB',
  white: '#FFFFFF',
  red: '#D0021B',
  green: '#7ec82c',
  blue: '#453FE3',
  shadow: 'rgba(0, 0, 0, 0.15)',
}

// EASINGS
export const Easings = {
  linear: 'cubic-bezier(0.250, 0.250, 0.750, 0.750)',
  quadIn: 'cubic-bezier(0.550, 0.085, 0.680, 0.530)',
  quadOut: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
  quadInOut: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
  cubicIn: 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
  cubicOut: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
  cubicInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
  quartIn: 'cubic-bezier(0.895, 0.030, 0.685, 0.220)',
  quartOut: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
  quartInOut: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
  quintIn: 'cubic-bezier(0.755, 0.050, 0.855, 0.060)',
  quintOut: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
  quintInOut: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
  sineIn: 'cubic-bezier(0.470, 0.000, 0.745, 0.715)',
  sineOut: 'cubic-bezier(0.390, 0.575, 0.565, 1.000)',
  sineInOut: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
  expoIn: 'cubic-bezier(0.950, 0.050, 0.795, 0.035)',
  expoOut: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
  expoInOut: 'cubic-bezier(1.000, 0.000, 0.000, 1.000)',
  circIn: 'cubic-bezier(0.600, 0.040, 0.980, 0.335)',
  circOut: 'cubic-bezier(0.075, 0.820, 0.165, 1.000)',
  circInOut: 'cubic-bezier(0.785, 0.135, 0.150, 0.860)',
  backIn: 'cubic-bezier(0.600, 0, 0.735, 0.045)',
  backOut: 'cubic-bezier(0.175, 0.885, 0.320, 1.275)',
  backInOut: 'cubic-bezier(0.680, 0, 0.265, 1)',
  customEase: 'cubic-bezier(0.000, 0.660, 0.445, 1.000)',
}

// FONTS
export const Font = {
  base: 'Overpass',
  title_font: 'Interstate-ExtraLight',
  title_font_bold: 'Interstate-bold',
}


// WEBPACK FOOTER //
// ./src/styles/core.js